import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pricing-carousel"
export default class extends Controller {
  static targets = ["container", "prevButton", "nextButton", "card"]

  connect() {
    this.isDragging = false
    this._onMouseUp = this.dragEnd.bind(this)
    window.addEventListener("mouseup", this._onMouseUp)
    requestAnimationFrame(() => this.setInitialCard())
    this.updateArrows()
  }

  disconnect() {
    window.removeEventListener("mouseup", this._onMouseUp)
  }

  scrollLeft() {
    this.scrollToCard(this.currentCardIndex() - 1)
  }

  scrollRight() {
    this.scrollToCard(this.currentCardIndex() + 1)
  }

  onScroll() {
    this.updateArrows()
  }

  // Mouse Dragging
  dragStart(e) {
    this.isDragging = true
    this.startX = e.pageX - this.containerTarget.offsetLeft
    this.scrollStart = this.containerTarget.scrollLeft
    this.containerTarget.style.cursor = "grabbing"
    this.containerTarget.style.userSelect = "none"
    // Disable snap while dragging so scrollLeft updates aren't overridden
    this.containerTarget.style.scrollSnapType = "none"
  }

  dragMove(e) {
    if (!this.isDragging) return
    e.preventDefault()
    const x = e.pageX - this.containerTarget.offsetLeft
    this.containerTarget.scrollLeft = this.scrollStart - (x - this.startX)
  }

  dragEnd() {
    if (!this.isDragging) return
    this.isDragging = false
    this.containerTarget.style.cursor = "grab"
    this.containerTarget.style.userSelect = ""
    // Re-enable snap — browser will snap to nearest card automatically
    this.containerTarget.style.scrollSnapType = ""
  }

  updateArrows() {
    const el = this.containerTarget
    const atStart = el.scrollLeft <= 0
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1

    if (this.hasPrevButtonTarget) {
      this.prevButtonTarget.classList.toggle("invisible", atStart)
    }
    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.classList.toggle("invisible", atEnd)
    }
  }

  setInitialCard() {
    if (this.cardTargets.length < 2 || this.containerTarget.scrollLeft > 0) return

    this.scrollToCard(1, "auto")
  }

  currentCardIndex() {
    const containerCenter = this.containerTarget.scrollLeft + (this.containerTarget.clientWidth / 2)

    return this.cardTargets.reduce((closestIndex, card, index) => {
      const cardCenter = card.offsetLeft + (card.offsetWidth / 2)
      const closestCard = this.cardTargets[closestIndex]
      const closestCenter = closestCard.offsetLeft + (closestCard.offsetWidth / 2)

      return Math.abs(cardCenter - containerCenter) < Math.abs(closestCenter - containerCenter) ? index : closestIndex
    }, 0)
  }

  scrollToCard(index, behavior = "smooth") {
    const boundedIndex = Math.max(0, Math.min(index, this.cardTargets.length - 1))
    const card = this.cardTargets[boundedIndex]
    const left = card.offsetLeft - ((this.containerTarget.clientWidth - card.offsetWidth) / 2)

    this.containerTarget.scrollTo({ left, behavior })
  }
}
